import { makePieActionObjs } from "shared/imports/pieActionGenerators"

// make get actions
const getBulkEmailObjs = makePieActionObjs("get", "bulk_email")
export const getBulkEmailPieActions = getBulkEmailObjs.pieDict

// make get actions for variants
const getABVariantsObjs = makePieActionObjs("get", "ab_variants")
export const getABVariantsPieActions = getABVariantsObjs.pieDict

// make patch actions
const patchBulkEmailObjs = makePieActionObjs("patch", "bulk_email")
export const patchBulkEmailPieActions = patchBulkEmailObjs.pieDict

// make patch M2M actions
const patchBulkEmailM2MObjs = makePieActionObjs("patch", "bulk_email_m2m")
export const patchBulkEmailM2MPieActions = patchBulkEmailM2MObjs.pieDict

// make post actions
const postBulkEmailObjs = makePieActionObjs("post", "bulk_email")
export const postBulkEmailPieActions = postBulkEmailObjs.pieDict

// make post actions
const cancelBulkEmailObjs = makePieActionObjs("cancel", "bulk_email")
export const cancelBulkEmailPieActions = cancelBulkEmailObjs.pieDict

// testing
const testingBulkEmailObjs = makePieActionObjs("testing", "bulk_email")
export const testingBulkEmailPieActions = testingBulkEmailObjs.pieDict

// sending
const sendingBulkEmailObjs = makePieActionObjs("sending", "bulk_email")
export const sendingBulkEmailPieActions = sendingBulkEmailObjs.pieDict

// attachments
const duplicateAttachmentObjs = makePieActionObjs("duplicate", "attachments")
export const duplicateAttachmentsActions = duplicateAttachmentObjs.pieDict

// Placeholders
const updatePlaceholdersObjs = makePieActionObjs("update_placeholders", "bulk_email")
export const updatePlaceholdersActions = updatePlaceholdersObjs.pieDict

const validatePlaceholdersObjs = makePieActionObjs("validate_placeholders", "bulk_email")
export const validatePlaceholdersActions = validatePlaceholdersObjs.pieDict

// Previews
const getEmailPreviewActionObjs = makePieActionObjs("get_preview", "bulk_email")
export const getEmailPreviewActions = getEmailPreviewActionObjs.pieDict

const getAiSuggestionObjs = makePieActionObjs("get_ai_suggestion", "bulk_email")
export const getAiSuggestionActions = getAiSuggestionObjs.pieDict

// all actions
const bulkEmailActions = {
    // getting
    ...getBulkEmailObjs.actionTypes,
    // getting AB Variants
    ...getABVariantsObjs.actionTypes,
    // patching
    ...patchBulkEmailObjs.actionTypes,
    ...patchBulkEmailM2MObjs.actionTypes,
    // posting
    ...postBulkEmailObjs.actionTypes,
    // canceling
    ...cancelBulkEmailObjs.actionTypes,
    // testing
    ...testingBulkEmailObjs.actionTypes,
    // sending
    ...sendingBulkEmailObjs.actionTypes,
    // duplicating attachments
    ...duplicateAttachmentObjs.actionTypes,
    // getting placeholders
    ...updatePlaceholdersObjs.actionTypes,
    // validating placeholders
    ...validatePlaceholdersObjs.actionTypes,
    // for making previews
    ...getEmailPreviewActionObjs.actionTypes,
    // for ChatGPT outbox suggestion
    ...getAiSuggestionObjs.actionTypes,

    // launch adv search
    START_ADV_SELECTION: "START_ADV_SELECTION",
    OUTBOX_SUBMIT_SEARCHIFY: "OUTBOX_SUBMIT_SEARCHIFY",
    OUTBOX_CANCEL_SEARCHIFY: "OUTBOX_CANCEL_SEARCHIFY",

    // compose actions
    UPDATE_RECIPIENTS_START: "UPDATE_RECIPIENTS_START",
    UPDATE_RECIPIENTS_FAIL: "UPDATE_RECIPIENTS_FAIL",
    UPDATE_RECIPIENTS_SUCCESS: "UPDATE_RECIPIENTS_SUCCESS",

    // AUTOSAVING
    AUTOSAVE_BULK_EMAIL_START: "AUTOSAVE_BULK_EMAIL_START",
    AUTOSAVE_BULK_EMAIL_BLOCKED: "AUTOSAVE_BULK_EMAIL_BLOCKED",
    AUTOSAVE_BULK_EMAIL_SUCCESS: "AUTOSAVE_BULK_EMAIL_SUCCESS",

    // updating
    UPDATE_BULK_EMAIL: "UPDATE_BULK_EMAIL",

    UPDATE_ABTEST: "UPDATE_ABTEST",

    // reset bulk_email
    RESET_BULK_EMAIL: "RESET_BULK_EMAIL",
    // reset placeholders
    RESET_BULK_EMAIL_PREVIEWS: "RESET_BULK_EMAIL_PREVIEWS",

    OUTBOX_SET_SUBJECT: "OUTBOX_SET_SUBJECT",

    SET_ACTIVE_BULK_EMAIL_ID: "SET_ACTIVE_BULK_EMAIL_ID",

    SET_IS_FROM_CAMPAIGN: "SET_IS_FROM_CAMPAIGN",
}

// default export
export default bulkEmailActions

/* OTHER */
export const EmailPreviewStatusCodes = {
    READY: "READY",
    VALID: "VALID",
    LOADING: "LOADING",
    INVALID: "INVALID",
}
